var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _reactNative = require("react-native-web");
var _utils = require("../../../utils");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var startAnimation = _ref.startAnimation;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    styles = _useState2[0],
    setStyles = _useState2[1];
  var _explositionDuration = 250;
  var _fadeOutDuration = 1000;
  var _fadeOutDelay = 0;
  var _drop = 30;
  var _containerOpacity = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var container = (0, _react.useMemo)(function () {
    return {
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: _containerOpacity
    };
  }, [_containerOpacity]);
  var _confetti = (0, _react.useMemo)(function () {
    return {
      DotPink: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: -18,
        _translateX: 0
      },
      DotPink2: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 25,
        _translateX: -11
      },
      DotYellow: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 11,
        _translateX: -9
      },
      SwirlBlue: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 0,
        _translateX: -20
      },
      SwirlPink: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: -14,
        _translateX: 20
      },
      SwirlPink2: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 28,
        _translateX: 18
      },
      SwirlYellow: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 30,
        _translateX: -5
      },
      TriangleBlue: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: -9,
        _translateX: -9
      },
      TriangleDarkGreen: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: -9,
        _translateX: 9
      },
      TriangleGreen: {
        translateX: new _reactNative.Animated.Value(0),
        translateY: new _reactNative.Animated.Value(0),
        _translateY: 7,
        _translateX: 20
      }
    };
  }, []);
  var _explosion = _reactNative.Animated.parallel([].concat((0, _toConsumableArray2["default"])(Object.keys(_confetti).map(function (key) {
    return _reactNative.Animated.timing(_confetti[key].translateY, {
      useNativeDriver: _utils.useNativeDriver,
      toValue: _confetti[key]._translateY,
      duration: _explositionDuration
    });
  })), (0, _toConsumableArray2["default"])(Object.keys(_confetti).map(function (key) {
    return _reactNative.Animated.timing(_confetti[key].translateX, {
      useNativeDriver: _utils.useNativeDriver,
      toValue: _confetti[key]._translateX,
      duration: _explositionDuration
    });
  }))));
  var _fadeOut = _reactNative.Animated.parallel([].concat((0, _toConsumableArray2["default"])(Object.keys(_confetti).map(function (key) {
    return _reactNative.Animated.timing(_confetti[key].translateY, {
      useNativeDriver: _utils.useNativeDriver,
      toValue: _confetti[key]._translateY + _drop,
      duration: _fadeOutDuration,
      delay: _fadeOutDelay
    });
  })), [_reactNative.Animated.timing(_containerOpacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 0,
    duration: _fadeOutDuration,
    delay: _fadeOutDelay
  })]));
  var _animate = (0, _react.useRef)(_reactNative.Animated.sequence([_reactNative.Animated.timing(_containerOpacity, {
    useNativeDriver: _utils.useNativeDriver,
    toValue: 1,
    duration: 1
  }), _explosion, _fadeOut])).current;
  var _setStyles = (0, _react.useCallback)(function () {
    var isReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _confettiStyles = {};
    for (var _key in _confetti) {
      var _ref2 = _confetti[_key],
        translateX = _ref2.translateX,
        translateY = _ref2.translateY;
      if (isReset) {
        translateX.setValue(0);
        translateY.setValue(0);
      }
      _confettiStyles[_key] = {
        position: 'absolute',
        transform: [{
          translateX: translateX
        }, {
          translateY: translateY
        }]
      };
    }
    setStyles(Object.assign({
      container: container
    }, _confettiStyles));
  }, [_confetti, container]);
  var _resetAnimation = (0, _react.useCallback)(function () {
    _animate.reset();
    _setStyles(true);
  }, [_animate, _setStyles]);
  (0, _react.useEffect)(function () {
    if (startAnimation) {
      _animate.start(_resetAnimation);
    }
  }, [startAnimation, _animate, _resetAnimation]);
  (0, _react.useEffect)(function () {
    _setStyles();
  }, [_setStyles]);
  (0, _react.useEffect)(function () {
    return function () {
      return _animate.stop();
    };
  });
  return {
    styles: styles
  };
};